module.exports = __webpack_public_path__ + "assets/img/level4.301517cd.png";